import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  METADATA_CONTAINER: `${cleanedFilename(__filename)}-metadata-container`,
};
